import type {
  ImportProfileCreate,
  ImportProfileResponse,
  ImportProfileUpdate,
  MappingCreate,
  MappingResponse,
  MappingUpdate,
} from '@flixflow/shared';
import { apiFetch } from './client.js';

export const importProfilesApi = {
  list: () => apiFetch<ImportProfileResponse[]>('/api/import-profiles'),
  get: (id: string) => apiFetch<ImportProfileResponse>(`/api/import-profiles/${id}`),
  create: (body: ImportProfileCreate) =>
    apiFetch<ImportProfileResponse>('/api/import-profiles', { method: 'POST', body }),
  update: (id: string, body: ImportProfileUpdate) =>
    apiFetch<ImportProfileResponse>(`/api/import-profiles/${id}`, { method: 'PUT', body }),
  delete: (id: string) =>
    apiFetch<void>(`/api/import-profiles/${id}`, { method: 'DELETE' }),

  // Mappings
  listMappings: (profileId: string) =>
    apiFetch<MappingResponse[]>(`/api/import-profiles/${profileId}/mappings`),
  createMapping: (profileId: string, body: MappingCreate) =>
    apiFetch<MappingResponse>(`/api/import-profiles/${profileId}/mappings`, {
      method: 'POST',
      body,
    }),
  updateMapping: (profileId: string, mid: string, body: MappingUpdate) =>
    apiFetch<MappingResponse>(`/api/import-profiles/${profileId}/mappings/${mid}`, {
      method: 'PUT',
      body,
    }),
  deleteMapping: (profileId: string, mid: string) =>
    apiFetch<void>(`/api/import-profiles/${profileId}/mappings/${mid}`, { method: 'DELETE' }),
  reorderMappings: (profileId: string, ids: string[]) =>
    apiFetch<void>(`/api/import-profiles/${profileId}/mappings/reorder`, {
      method: 'POST',
      body: { ids },
    }),
};
